import React from 'react';

const FooterUi = () => {
    return (
        <>
            <div className='px-4 mx-auto sm:max-w-xl md:max-w-full  md:px-24 lg:px-8'>
                <div>
                    <h6 className='text-md font-semibold text-gray-800 dark:text-white lg:text-md text-left ml-8'>ORGANIZACIÓN GENERAL:</h6>
                </div>
                <div className='bg-white dark:bg-gray-900'>
                    <div className='container px-6 py-16 mx-auto text-left -mt-12'>
                        <div className='mx-auto'>
                            <div className='grid grid-cols-2 gap-8 md:grid-cols-1 lg:grid-cols-1'>
                                <div className='flex items-center justify-center col-span-2 md:col-span-2 lg:col-span-1'>
                                    <img src='/assets/logo2.png' alt='logo gobla'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FooterUi;